import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from './IELTSCourse';
import { listeningStrategiesData, getDataForDifficulty } from './data/skills/listening/listeningStrategies';

export default function ListeningStrategies() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : listeningStrategiesData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
